/**
 * Client routing SSOT: Intelligence for discovery, FSM /advance only for booking.
 */
/** Legacy FSM quiz — must not be shown to clients. */
export const ATHENA_LEGACY_QUIZ_STEPS = new Set([
    'step_zone',
    'step_match',
    'step_problem',
    'step_massage_goal',
]);
/** Free-text assist → CdlitAthenaIntelligenceService. */
export const ATHENA_INTELLIGENCE_ASSIST_STEPS = new Set([
    'opening',
    'consult_active',
    'step_recommendation',
    ...ATHENA_LEGACY_QUIZ_STEPS,
]);
/** FSM booking pipeline — client may use /advance here. */
export const ATHENA_BOOKING_FSM_STEPS = new Set([
    'step_safety',
    'step_safety_clarify',
    'step_staff',
    'step_slots',
    'step_contact',
    'step_confirm',
    'booking_pending',
    'booking_completed',
    'slot_conflict',
    'handoff_requested',
    'yclients_unavailable',
    'provider_unavailable',
]);
/** Catalog optionIds allowed on /advance (booking + service pick). */
export const ATHENA_CLIENT_ADVANCE_OPTION_IDS = new Set([
    'accept-service',
    'next-recommendation',
    'handoff-other',
    'safety-none',
    'safety-sensitive',
    'safety-allergy',
    'safety-medication',
    'safety-chronic',
    'continue-safe',
    'handoff-safety',
    'confirm-booking',
    'retry-slots',
]);
/** FSM actions blocked on client /advance — discovery quiz only via intelligence. */
export const ATHENA_DISCOVERY_FSM_ACTIONS = new Set([
    'select_intent',
    'select_intent_know',
    'select_intent_help',
    'select_intent_slots',
    'select_intent_price',
    'select_zone',
    'select_zone_massage',
    'select_zone_relax',
    'select_problem',
    'select_massage_goal',
]);
export function isAthenaLegacyQuizStep(step) {
    return ATHENA_LEGACY_QUIZ_STEPS.has(step);
}
export function isAthenaIntelligenceAssistStep(step) {
    return ATHENA_INTELLIGENCE_ASSIST_STEPS.has(step);
}
export function isAthenaBookingFsmStep(step) {
    return ATHENA_BOOKING_FSM_STEPS.has(step);
}
export function isAthenaClientAdvanceOptionId(optionId) {
    if (optionId.startsWith('pick-service-'))
        return true;
    return ATHENA_CLIENT_ADVANCE_OPTION_IDS.has(optionId);
}
export function isAthenaDiscoveryFsmAction(action) {
    return ATHENA_DISCOVERY_FSM_ACTIONS.has(action);
}
/** Booking steps where assist-other stays on legacy assist (contact/confirm/FSM safety chips). */
export const ATHENA_ASSIST_LEGACY_ONLY_STEPS = new Set([
    'step_contact',
    'step_confirm',
    'step_safety',
    'step_safety_clarify',
]);
/** Free-text → intelligence always (ATHENA.1 — no legacy assist discovery fork). */
export function shouldRouteAssistOtherToIntelligence(_step, _snapshot) {
    return true;
}
/** True when client may call POST .../advance with this optionId on this step. */
export function isAthenaClientAdvanceAllowed(step, optionId) {
    if (!isAthenaClientAdvanceOptionId(optionId))
        return false;
    if (optionId.startsWith('pick-service-'))
        return step === 'step_recommendation';
    if (step === 'step_recommendation') {
        return optionId === 'accept-service' || optionId === 'next-recommendation' || optionId === 'handoff-other';
    }
    if (step === 'step_slots') {
        return optionId === 'next-recommendation' || optionId === 'handoff-other';
    }
    if (step === 'step_safety')
        return optionId.startsWith('safety-');
    if (step === 'step_safety_clarify')
        return optionId === 'continue-safe' || optionId === 'handoff-safety';
    if (step === 'step_confirm')
        return optionId === 'confirm-booking';
    if (step === 'slot_conflict')
        return optionId === 'retry-slots';
    return false;
}
//# sourceMappingURL=athena-routing.js.map